import { render, staticRenderFns } from "./Receivable.vue?vue&type=template&id=a5f12be6&scoped=true&"
import script from "./Receivable.vue?vue&type=script&lang=js&"
export * from "./Receivable.vue?vue&type=script&lang=js&"
import style0 from "./Receivable.vue?vue&type=style&index=0&id=a5f12be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f12be6",
  null
  
)

export default component.exports